import { frontendLogger } from './loggerCore';
import {
  normalizeObservabilityContext,
  type ObservabilityContext,
} from './observability';

const FETCH_BASE = { category: 'fetch', surface: 'web' } as const;

export function logFetchRequest(
  url: string,
  method: string,
  context?: ObservabilityContext
): void {
  const merged = normalizeObservabilityContext({ ...context });
  frontendLogger.debug(`Fetch request: ${method.toUpperCase()} ${url}`, {
    ...FETCH_BASE,
    url,
    method: method.toUpperCase(),
    ...merged,
  });
}

export function logFetchSuccess(
  url: string,
  method: string,
  status: number,
  context?: ObservabilityContext
): void {
  const merged = normalizeObservabilityContext({ ...context });
  frontendLogger.debug(`Fetch success: ${method.toUpperCase()} ${url}`, {
    ...FETCH_BASE,
    url,
    method: method.toUpperCase(),
    http_status_code: status,
    result: 'success',
    ...merged,
  });
}

export function logFetchFailed(
  url: string,
  method: string,
  error: Error | string,
  context?: ObservabilityContext
): void {
  const merged = normalizeObservabilityContext({ ...context });
  frontendLogger.error(`Fetch failed: ${method.toUpperCase()} ${url}`, {
    ...FETCH_BASE,
    url,
    method: method.toUpperCase(),
    error: error instanceof Error ? error.message : error,
    result: 'error',
    ...merged,
  });
}

export const fetchLogger = {
  request: logFetchRequest,
  success: logFetchSuccess,
  failed: logFetchFailed,
};
